const quickStats = [
  { label: '今日曝光主角', value: '24', unit: '位', icon: 'ri-user-3-line', cls: 'bg-primary-50 text-primary-600' },
  { label: '刚刚流出快讯', value: '36', unit: '条', icon: 'ri-broadcast-line', cls: 'bg-accent-50 text-accent-600' },
  { label: '全网追踪专题', value: '9', unit: '个', icon: 'ri-radar-line', cls: 'bg-secondary-100 text-secondary-700' },
  { label: '热议风向累计', value: '128', unit: '万+', icon: 'ri-chat-3-line', cls: 'bg-background-200 text-foreground-600' },
];

export default function StatsBar() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 pb-2 md:px-6">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {quickStats.map((s) => (
          <div key={s.label} className="flex items-center gap-3 rounded-xl border border-background-200/70 bg-background-50 px-4 py-3">
            <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${s.cls}`}>
              <i className={`${s.icon} text-lg`}></i>
            </span>
            <div className="min-w-0">
              <div className="flex items-baseline gap-1">
                <span className="font-heading text-xl font-bold text-foreground-950">{s.value}</span>
                <span className="text-[11px] text-foreground-500">{s.unit}</span>
              </div>
              <p className="truncate text-[11px] text-foreground-500">{s.label}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}